import { render, staticRenderFns } from "./ProductInfoCard.vue?vue&type=template&id=2f0ff54c&scoped=true&"
import script from "./ProductInfoCard.vue?vue&type=script&lang=js&"
export * from "./ProductInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoCard.vue?vue&type=style&index=0&id=2f0ff54c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0ff54c",
  null
  
)

export default component.exports